import {
  CheckboxGroupButtons,
  FloatingFormItem,
  InputDecimal,
} from '@/components/_common';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import { Col, Form, FormInstance, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import HoursCostMoreOptions from './HoursCostMoreOptions';
import {
  HourlyCostFilterDateBy,
  HourlyCostSituation,
  QuestReportHourlyFormValues,
} from '@/core/domain/questReport/Reports/HourlyCost/HourlyCost.types';
import { useDefaultEmptyFieldError } from '@/hooks';

interface Props {
  form: FormInstance<QuestReportHourlyFormValues>;
}

const ProductiveHoursCostForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;
  const requiredField = useDefaultEmptyFieldError();

  const situationOptions = [
    {
      label: intl.formatMessage({
        id: 'productiveHoursCost.form.situation.open',
      }),
      value: HourlyCostSituation.open,
    },
    {
      label: intl.formatMessage({
        id: 'productiveHoursCost.form.situation.authorized',
      }),
      value: HourlyCostSituation.authorized,
    },
    {
      label: intl.formatMessage({
        id: 'productiveHoursCost.form.situation.closed',
      }),
      value: HourlyCostSituation.closed,
    },
    {
      label: intl.formatMessage({
        id: 'productiveHoursCost.form.situation.canceled',
      }),
      value: HourlyCostSituation.cancelled,
    },
  ];

  return (
    <Form form={form}>
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <>
            <Title level={5}>
              {intl.formatMessage({
                id: 'productiveHoursCost.form.filterByDate',
              })}
            </Title>

            <Form.Item
              name="filterDateBy"
              initialValue={HourlyCostFilterDateBy.authorization}
              noStyle
            >
              <Radio.Group optionType="button" buttonStyle="solid" size="large">
                <Radio value={HourlyCostFilterDateBy.entry}>
                  {intl.formatMessage({
                    id: 'productiveHoursCost.form.filterByDate.entrance',
                  })}
                </Radio>
                <Radio value={HourlyCostFilterDateBy.authorization}>
                  {intl.formatMessage({
                    id: 'productiveHoursCost.form.filterByDate.authorization',
                  })}
                </Radio>

                <Radio value={HourlyCostFilterDateBy.closing}>
                  {intl.formatMessage({
                    id: 'productiveHoursCost.form.filterByDate.shutdown',
                  })}
                </Radio>

                <Radio value={HourlyCostFilterDateBy.leave}>
                  {intl.formatMessage({
                    id: 'productiveHoursCost.form.filterByDate.exit',
                  })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </>
        }
      />

      <Row gutter={[24, 6]}>
        <Col lg={6} span={24} md={12}>
          <FloatingFormItem
            name="costByEmployee"
            label={intl.formatMessage({
              id: 'productiveHoursCost.form.costPerEmployee',
            })}
            rules={[requiredField]}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>

        <Col sm={24}>
          <Title level={5}>
            {intl.formatMessage({
              id: 'productiveHoursCost.form.situation',
            })}
          </Title>

          <Form.Item
            name="situation"
            initialValue={[HourlyCostSituation.authorized]}
          >
            <CheckboxGroupButtons options={situationOptions} />
          </Form.Item>
        </Col>

        <Col span={24}>
          <HoursCostMoreOptions />
        </Col>
      </Row>
    </Form>
  );
};

export default ProductiveHoursCostForm;
